import { AppVariant } from '../models/app-variant.enum';

export const PATH_TO_VARIANT: [RegExp, AppVariant][] = [
  [/^\/ie\/?/, AppVariant.IeSidedoor],
  [/^\/amdea\/?/, AppVariant.GbSidedoorAmdea],
  [/^\/small-domestic-appliances\/?/, AppVariant.GbSidedoorSda],
  [/^\/promo\/?/, AppVariant.GbSidedoorPromo],
  [/^\/register\/?/, AppVariant.GbSidedoor],
];
